import { forwardRef, type InputHTMLAttributes } from 'react';

export interface EditorTitleProps
  extends Omit<InputHTMLAttributes<HTMLInputElement>, 'children'> {
  id: string;
  /** Screen-reader name for the title input (no visible label). */
  ariaLabel?: string;
  'data-testid'?: string;
  /** When true, select all text on focus (e.g. default untitled placeholder). */
  selectAllOnFocus?: boolean;
}

export const EditorTitle = forwardRef<HTMLInputElement, EditorTitleProps>(
  function EditorTitle(
    {
      id,
      ariaLabel = 'Title',
      className,
      'data-testid': dataTestId,
      selectAllOnFocus = false,
      onFocus,
      ...rest
    },
    ref
  ) {
    return (
      <div className={['pn-editor-title', className].filter(Boolean).join(' ')}>
        <input
          ref={ref}
          id={id}
          type="text"
          className="pn-editor-title-input"
          data-testid={dataTestId}
          {...rest}
          onFocus={(e) => {
            if (selectAllOnFocus) {
              e.currentTarget.select();
            }
            onFocus?.(e);
          }}
          aria-label={ariaLabel}
        />
        <hr className="pn-editor-title-rule" aria-hidden="true" />
      </div>
    );
  }
);
